import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { FontBasline } from "../components/shared/FontBaseline";
import { ScrollWrapper } from "../helpers/module.helper";
import axios from "axios";

const TextModule = (props) => {
  const { orderId, eventId, lang, eventName, preview } = props;
  const { text } = props.settings;

  let parsedText = text;
  if (text && !preview)
    parsedText = text
      .toString()
      .replace(/\[event\]/gi, eventName)
      .replace(/\[eventName\]/gi, eventName);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        flexDirection: "column",
        display: "flex",
      }}
    >
      <FontBasline /* font={fonts} */ template={props.settings} />
      <ScrollWrapper {...props}>
        <div
          className="jir-scroll"
          style={{
            ...props.settings,
            width: "100%",
            height: "100%",
            overflow: "auto",
            letterSpacing: 'normal'
          }}
          dangerouslySetInnerHTML={{__html: parsedText}}
        >
   {/*        {parsedText} */}
        </div>
      </ScrollWrapper>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    fonts: state.cms.fonts,
    template: state.template.template ? state.template.template.content : undefined,
  };
}
export default connect(mapStateToProps)(TextModule);
